import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../../templates/Ui';
import { getAppThemeName } from '../../../services/appTheme';
const StyledValue = styled.span `
    position: absolute;
    bottom: 0;
    left: 0;
    display: none;
    align-items: center;
    justify-content: center;
    opacity: 0;
    background-color: ${getAppThemeName() === 'invoned'
    ? props => props.theme.tertiary
    : props => props.theme.primary.base};
    min-width: 110px;
    height: 34px;
    color: ${props => props.appTheme === 'invoned'
    ? props.theme.primary.base
    : color.body.base};
    border-radius: 6px;
    transition: all 100ms ease-in;
    font-weight: 700;

    @media only screen and (min-width: 992px) {
        display: flex;
    }

    &:before {
        content: '';
        position: absolute;
        top: -5px;
        transform: translateX(-50%);
        left: 50%;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid
            ${getAppThemeName() === 'invoned'
    ? props => props.theme.tertiary
    : props => props.theme.primary.base};
    }
`;
const StatFullValue = ({ children }) => (_jsx(StyledValue, { className: "stat-value stat-value--full", appTheme: getAppThemeName(), children: children }));
export default StatFullValue;
